import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EPageLayout, PageLayoutComponent } from "@zaeper/angular-dashboard-view-lib";
import { InfoCardComponent } from "../../components/card/info-card.component";
import { ButtonModule } from "primeng/button";
import { ZTemplateDirective } from '@zaeper/angular-core-lib';

@Component( {
  selector: 'app-start-overview-page',
  imports: [ PageLayoutComponent, InfoCardComponent, ZTemplateDirective, ButtonModule ],
  templateUrl: './start-overview-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
} )
export class StartOverviewPageComponent {
  protected readonly ePageLayout = EPageLayout;

  constructor(activatedRoute: ActivatedRoute) {
  }
}
